import { DeskDossier, DeskFolder } from 'client/api/backend/schemas';
import { registerToolkitObjectType } from 'client/components/toolkit/objects/registerToolkitObjectType';

export const PersonalDossierToolkitObject =
  registerToolkitObjectType<DeskDossier>('personal-dossier');
